import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  CloseButton,
} from "@chakra-ui/core";
import { RouterContext } from "next/dist/next-server/lib/router-context";
import Router from "next/router";

// NOTE: Toasts lose react context: https://github.com/bmcmahen/toasted-notes#using-context
// The following providers are missing: AppProvider, ApolloProvider, ThemeProvider

const Toast = ({ title, description, isClosable, onClose, ...props }) => (
  <RouterContext.Provider value={Router}>
    <Alert
      variant="solid"
      textAlign="left"
      boxShadow="lg"
      rounded="md"
      alignItems="start"
      m={2}
      pr={8}
      {...props}
    >
      <AlertIcon />
      <Box flex="1">
        {title && <AlertTitle>{title}</AlertTitle>}
        {description && <AlertDescription>{description}</AlertDescription>}
      </Box>
      {isClosable && (
        <CloseButton
          size="sm"
          onClick={onClose}
          position="absolute"
          right="4px"
          top="4px"
          border="none"
          rounded="full"
        />
      )}
    </Alert>
  </RouterContext.Provider>
);

export default Toast;
